import { mapDTO } from '@twistezo/ts-dto-mapper'

import { Schema } from 'features/inventory/domain/forms/RichPlacementsForm/sections/MultiAnchorForm/schema'
import { Variables } from './types'

type From = Schema
type To = Omit<Variables, 'domainId'>

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({
      customizeAppearance,
      customizeBasicSettings,
      customStyling,
      displayAfterUserInteraction,
      enabled,
      fullWidthMode,
      showCloseButton,
      singleAdViewTime,
    }: From): To => ({
      customizeApperanceEnabled: customizeAppearance,
      customizeBasicSettingsEnabled: customizeBasicSettings,
      customStyling: customStyling || null,
      displayAfterUserInteractionEnabled: displayAfterUserInteraction,
      enabled,
      fullWidthModeEnabled: fullWidthMode,
      showCloseButtonEnabled: showCloseButton,
      singleAdViewTime,
    }),
  )
